module.exports = __webpack_public_path__ + "img/icon-table.3231d157.svg";